import * as RadixSelect from '@radix-ui/react-select';
import { forwardRef } from 'react';

import { cn } from '@air/utils-tailwind';

export type SelectContentProps = RadixSelect.SelectContentProps;

export const SelectContent = forwardRef<HTMLDivElement, SelectContentProps>(
  ({ children, className, position = 'popper', sideOffset = 8, ...restOfProps }, forwardedRef) => {
    return (
      <RadixSelect.Portal>
        <RadixSelect.Content
          className={cn(
            'relative z-portal flex max-h-[--radix-select-content-available-height] w-full min-w-[var(--radix-select-trigger-width)] radix-side-bottom:animate-slide-up radix-side-top:animate-slide-down flex-col gap-2 overflow-hidden rounded-4 ads:border-input ads:bg-raised bg-surface-1 p-2 ads:text-primary text-gray-12 shadow-popover outline-none dark:border dark:border-gray-5',
            className,
          )}
          data-testid="SELECT_CONTENT"
          position={position}
          sideOffset={sideOffset}
          {...restOfProps}
          ref={forwardedRef}
        >
          <RadixSelect.Viewport>{children}</RadixSelect.Viewport>
        </RadixSelect.Content>
      </RadixSelect.Portal>
    );
  },
);

SelectContent.displayName = 'SelectContent';
